<article class="ts-page ts-nf">
  <!-- A page came loose from a stack of books and drifts on a red thread, like a kite.
       Its page number is 404. -->
  <svg class="ts-nf__art" viewBox="0 0 320 170" aria-hidden="true">
    <ellipse class="ts-nf__shadow" cx="112" cy="153" rx="84" ry="4"/>

    <!-- Two books lying flat: cover, page block, spine -->
    <g class="ts-nf__book ts-nf__book--low">
      <rect class="ts-nf__cover" x="34" y="128" width="148" height="24" rx="3"/>
      <rect class="ts-nf__pages" x="46" y="131" width="133" height="18" rx="1"/>
      <path class="ts-nf__edges" d="M48,136 H177 M48,140 H177 M48,144 H177"/>
    </g>
    <g class="ts-nf__book ts-nf__book--top">
      <rect class="ts-nf__cover" x="50" y="106" width="122" height="22" rx="3"/>
      <rect class="ts-nf__pages" x="61" y="109" width="108" height="16" rx="1"/>
      <path class="ts-nf__edges" d="M63,113.5 H167 M63,117.5 H167 M63,121.5 H167"/>
      <!-- the gap where the page used to be -->
      <path class="ts-nf__gap" d="M140,109 V125"/>
    </g>

    <g class="ts-nf__kite">
      <path class="ts-nf__thread" d="M140,111 C158,90 144,68 178,62 C208,57 220,84 250,74"/>
      <g class="ts-nf__flutter">
        <g transform="rotate(12 250 74)">
          <path class="ts-nf__page" d="M250,14 H290 L297,21 V74 H250 Z"/>
          <path class="ts-nf__fold" d="M290,14 V21 H297"/>
          <path class="ts-nf__lines" d="M257,27 H289 M257,34 H289 M257,41 H289 M257,48 H283 M257,55 H289"/>
          <text class="ts-nf__number" x="273.5" y="68" text-anchor="middle">404</text>
        </g>
      </g>
    </g>
  </svg>

  <header class="ts-page__head ts-nf__head">
    <p class="t-meta ts-page__eyebrow">404 · Page not found</p>
    <h1 class="ts-page__title">This page <em>came loose.</em></h1>
    <p class="ts-page__lede">
      Maybe it was never written, or it slipped out somewhere along the way.
      @if (missingPath) {
        There's nothing at <code class="ts-nf__path">{{ missingPath }}</code>.
      }
    </p>
  </header>

  <nav class="ts-nf__ways" aria-label="Ways back">
    <a class="ts-nf__home" [routerLink]="['/']">
      Follow the thread home
      <span aria-hidden="true">→</span>
      <svg class="ts-nf__home-thread" viewBox="0 0 300 24" preserveAspectRatio="none" aria-hidden="true"><path d="M4,14 C48,6 92,20 140,12 C186,5 232,8 262,14 C276,17 288,15 296,9"/></svg>
    </a>
    @if (userIsLoggedIn) {
      <a class="ts-nf__write" [routerLink]="['/dashboard']">Or write the missing page yourself</a>
    } @else {
      <a class="ts-nf__write" [routerLink]="['/account/auth/signup']">Or write the missing page yourself</a>
    }
  </nav>
</article>
